module.exports = __webpack_public_path__ + "img/pemila.4349e503.png";